import { useEffect, useState } from 'react';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClient } from '../../../../context/ClientStatusContext';
import { fetchSuvisiaciProcesList } from '../../../../client/external/indexer/suvisiaciProcesListClient';
import SuvisiaciProces from '../../../../model/legislativnyMaterial/SuvisiaciProces';

interface ReturnType {
  suvisiaciProcesList: SuvisiaciProces[];
  suvisiaciProcesListStatus: ClientStatus;
}

export default (
  dopyt: string,
  limit: number,
): ReturnType => {
  const [, setAction] = useState<NodeJS.Timeout>(undefined);
  const { wrapClient, status, data } = useClient(fetchSuvisiaciProcesList);

  useEffect(() => {
    if (dopyt.trim().length > 0) {
      setAction(prevState => {
        clearTimeout(prevState);
        return prevState;
      });

      const act = setTimeout(async () => {
        await wrapClient(dopyt, limit);
      }, 300);

      setAction(act);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dopyt, limit]);

  return {
    suvisiaciProcesList: data || [],
    suvisiaciProcesListStatus: status,
  };
};
